import { materialCell } from './materialDisplay';

/**
 * Etiqueta de un material con su cantidad y unidad (`Nombre × 10 kg`).
 * @param {Object} article Material con `article_name`, cantidad y `unit`.
 * @param {string} quantityKey Campo de la cantidad (`quantity`, `requested_quantity`).
 * @returns {string} Etiqueta del chip.
 */
export const formatMaterialArticleLabel = (article, quantityKey) =>
  `${article.article_name} × ${materialCell('quantity', article[quantityKey])}${
    article.unit ? ` ${article.unit}` : ''
  }`;
